/**
 * This is hardcoded from the old aha-editor minor version. We rarely need to change this, but if we
 * ever do, it needs to be changed in Faye + all clients.
 */
export const collaborationServerVersion = '1.4';
